import { render, staticRenderFns } from "./ReminderAdd.vue?vue&type=template&id=d61d4842&"
import script from "./ReminderAdd.vue?vue&type=script&lang=js&"
export * from "./ReminderAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports